import { Images } from "../theme";

export const CATEGORIES = {
	pvc_alu: {
		windows: {
			image: Images.windows,
			// placeholder: Images.windows_placeholder,
			products: [{ key: "gealan" }, { key: "rehau" }],
			gallery: Images.gallery.pvc_alu.windows,
		},
		pvc_doors: {
			image: Images.pvc_doors,
			products: [{ key: "exterior" }, { key: "interior" }, { key: "sliding" }],
			gallery: Images.gallery.pvc_alu.pvc_doors,
		},
		glass: {
			image: Images.glass,
			products: null,
		},
		rollers: {
			image: Images.rollers,
			products: null,
			gallery: Images.gallery.pvc_alu.rollers,
		},
		garage_doors: {
			image: Images.garage_doors,
			products: null,
			gallery: Images.gallery.pvc_alu.garage_doors,
		},
		aluminum_joinery: {
			image: Images.aluminum_joinery,
			products: null,
			gallery: Images.gallery.pvc_alu.aluminum_joinery,
		},
	},
	wood: {
		furniture: {
			image: Images.furnitureHero,
			products: [
				{ key: "mdf", gallery: Images.gallery.furniture.mdf },
				{ key: "pal", gallery: Images.gallery.furniture.pal },
			],
		},
		doors: {
			image: Images.wood_doors,
			products: [
				{ key: "wood", gallery: Images.gallery.doors.wood },
				{ key: "mdf", gallery: Images.gallery.doors.mdf },
			],
		},
	},
};
